import { Component } from '@angular/core';
import { getUserFromJwtCookie } from '../../../../../shared/helpers/getUserCookie';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'vigp-unauthorized',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent {
  constructor(
    readonly _router: Router,
  ) { }

  showContent = true;

  ngOnInit(): void {
  }

  redirectToHome(): void {
    // window.location.href = 'https://tarifario.core.dev.protectasecuritycloud.pe/';
    // this.showContent = false;
  }
}
